export default "__VITE_ASSET__aiSwDZ4H__"